module.exports = __webpack_public_path__ + "static/media/silvia_borteanu.38b6e40f.jpg";